import { FullScreenModal, Text } from '@ds'

import { CameraCardFolder } from '../CameraCardFolder'
import styles from './CameraCardFolderModal.module.scss'

type Props = {
  isOpen: boolean
  onClose: () => void
  number: number
  title: string
  img: string
  description: string
  renderMask: (children: React.ReactNode) => React.ReactNode
}

export const CameraCardFolderModal = ({
  number,
  title,
  img,
  description,
  isOpen,
  onClose,
  renderMask,
}: Props) => {
  return (
    <FullScreenModal
      isOpen={isOpen}
      onClose={onClose}
      backgroundType="backdrop"
    >
      <div className={styles.container}>
        <CameraCardFolder
          number={number}
          title={title}
          img={img}
          renderMask={renderMask}
          isAnimated
        />
        <Text as="div" type="body-4" className={styles.description}>
          {description}
        </Text>
      </div>
    </FullScreenModal>
  )
}
